import React from "react";
import { Formik } from "formik";
import * as Yup from "yup";

import { Form, TextInputField } from "@jsluna/form";
import {
  SubmitButton,
  Notification,
  NotificationStatuses,
  Card,
} from "@jsainsburyplc/id-ui-common";

import { EMAIL_REGEX } from "utils/validation";
import useCookies from "hooks/useCookies";
import { INVALID_EMAIL_MESSAGE } from "constants/messages";

const FORM_SCHEMA = Yup.object({
  email: Yup.string()
    .matches(EMAIL_REGEX, INVALID_EMAIL_MESSAGE)
    .required("Email is required"),
  lastName: Yup.string().required("Last name is required"),
});

const INITAL_FORM_VALUES = {
  email: "",
  lastName: "",
};

const InitiateAccountRecoveryForm = ({ onSubmit }) => {
  const { email } = useCookies();

  return (
    <Formik
      initialValues={{ ...INITAL_FORM_VALUES, email: email ? email : "" }}
      validationSchema={FORM_SCHEMA}
      validateOnMount={true}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        getFieldProps,
        errors,
        isSubmitting,
        isValid,
        touched,
        status = {},
      }) => (
        <>
          {status.isError && (
            <div className="ln-u-margin-bottom*2">
              <Notification type={NotificationStatuses.ERROR_TYPE}>
                That email or last name doesn't look right. Please try again.
              </Notification>
            </div>
          )}
          <Card>
            <Form onSubmit={handleSubmit}>
              <TextInputField
                {...getFieldProps("email")}
                name="email"
                label="Email address"
                type="email"
                maxLength={128}
                error={touched.email && errors?.email}
                required
              />

              <TextInputField
                {...getFieldProps("lastName")}
                name="lastName"
                label="Last name"
                type="text"
                error={touched.lastName && errors?.lastName}
                required
              />

              <div className="ln-u-text-align-center ln-u-push-top-sm">
                <SubmitButton
                  disabled={isSubmitting || !isValid}
                  style={{ maxWidth: "20rem" }}
                  fullWidth={true}
                  isLoading={isSubmitting}
                  isLoadingLabel="Loading..."
                  label="Continue"
                />
              </div>
            </Form>
          </Card>
        </>
      )}
    </Formik>
  );
};

export default InitiateAccountRecoveryForm;
